<div class="card">
  <div class="card__header">
    <ng-content select="[header]"></ng-content>
  </div>
  <div class="card__body">
    <ng-content select="[body]"></ng-content>
  </div>
</div>
